module.exports = __webpack_public_path__ + "img/standard-shoot.0ec99a49.png";